<template>
  <div>这是A页面</div>
</template>

<script>
export default {
  name: "standardA"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/veiws/standardA.vue